export default {
  noMatchesFound: 'Nie znaleziono nakładania się sygnałów między źródłem a celem. Migracja nie jest możliwa',
};
